import React from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { colors } from '../../styles/colors'

const Container = styled.div`
    width: 38px;
    height: 38px;

    .line {
        width: 100%;
        height: 4px;
        border-radius: 2px;
        transition: all .5s;
        background: ${colors.dark_blue};
    }

    .top-line {
        transform: translateY(32px);
    }
    .bottom-line {
        transform: translateY(10px);
    }

    @media (min-width: 1199.98px) {
        display: none !important;
    }
`

export const BurgerMenuIco = () => {

    const dispatch = useDispatch()

    return (
        <Container className='hide-on-search-bar-focused'  onClick={()=> dispatch({ type:'MOBILE_MENU_OPENED' }) } >
            <div className="line top-line" />
            <div className="line md-line" />
            <div className="line bottom-line" />
        </Container>
    )
}
